<template>
  <AppHead>
    <title>EMARF scan | {{ $route.meta.title }}</title>
    <meta name="description" content="写す、出会う、つながる 捨てない未来" />

    <!-- Social -->
    <meta property="og:title" content="EMARF scan" />
    <meta
      property="og:description"
      content="写す、出会う、つながる 捨てない未来"
    />
    <meta property="og:image" content="@/ogp.jpg" />

    <!-- Twitter -->
    <meta name="twitter:title" content="EMARF scan" />
    <meta
      name="twitter:description"
      content="写す、出会う、つながる 捨てない未来"
    />
    <meta name="twitter:image" content="@/ogp.jpg" />
    <meta name="twitter:card" content="summary_large_image" />
  </AppHead>
  <v-app v-bind:style="{ backgroundColor: setBgColor }">
    <!-- Maintenance Popup - Remove this when maintenance is done -->
    <v-overlay
      v-if="showMaintenancePopup"
      :model-value="true"
      persistent
      class="maintenance-overlay"
    >
      <div class="maintenance-popup">
        <v-icon size="48" color="warning" class="mb-4">mdi-wrench</v-icon>
        <h2>メンテナンス中</h2>
        <p>
          ご利用の皆様にはご迷惑をおかけし、大変申し訳ございません。
          <br />メンテナンス終了までしばらくお待ちください。 <br />
          <a
            href="mailto:support@vuild.co.jp"
            aria-label="メールでサポートに連絡"
          >
            support@vuild.co.jp
          </a>
        </p>
      </div>
    </v-overlay>
    <!-- End Maintenance Popup -->

    <div class="container">
      <Header></Header>
      <v-main>
        <router-view />
      </v-main>
      <Footer />
      <VSnackbar />
    </div>
  </v-app>
</template>
<script>
import Header from "@/components/molecules/Header";
import Footer from "@/components/molecules/Footer";
import VSnackbar from "@/components/atoms/VSnackbar";
import { mapActions } from "vuex";

export default {
  components: {
    Header,
    Footer,
    VSnackbar,
  },

  created() {
    this.fetchAuthUser();
    this.getUsers();
    this.getMaterials();
    this.getLocations();
  },

  computed: {
    showMaintenancePopup() {
      const maintenanceRoutes = ["/", "/scan", "/materials"];
      return maintenanceRoutes.includes(this.$route.path);
    },
    setBgColor: function () {
      return this.$route.path === "/scan" ? "#35383b" : "#F8F5F2";
    },
    auth() {
      return this.$store.state.auth.authUser;
    },
    user() {
      return this.$store.getters["user/user"](this.auth.username);
    },
  },
  methods: {
    ...mapActions("auth", ["fetchAuthUser"]),
    ...mapActions("user", ["getUsers"]),
    ...mapActions("materials", ["getMaterials"]),
    ...mapActions("locations", ["getLocations"]),
  },
};
</script>
<style lang="scss">
//Global CSS here
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@500;600;700&display=swap");
* {
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background-color: $surfaceBase;
}
a:-webkit-any-link {
  text-decoration: none;
}
img {
  vertical-align: top;
}
#app {
  text-align: center;
  color: $contentsDarkHigh;
}
//Component custom style here (use content-class option)
.custom-snackbar {
  .v-snackbar__wrapper {
    border-radius: $radiusLg;
    background-color: $surfaceDark;
    margin: 16px;
    @include body2;
    @include mq(sp) {
      margin: 16px 16px 104px;
    }
  }
  .v-snackbar__content {
    display: flex;
    align-items: center;
    padding: 12px;
    @include mq(sp) {
    }
  }
}
.maintenance-overlay {
  z-index: 9999 !important;

  .v-overlay__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
}
.maintenance-popup {
  background: white;
  padding: 48px 32px;
  border-radius: 16px;
  text-align: center;
  max-width: 540px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  h2 {
    margin-bottom: 16px;
    font-size: 20px;
    color: #333;
  }

  p {
    color: #666;
    line-height: 1.6;
  }

  a {
    text-decoration: underline;
  }
}
</style>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  @include mq(lg) {
    width: 100%;
    margin: 0 auto;
    max-width: 640px;
  }
  @include mq(mdsp) {
    padding: 0 16px;
  }
}
</style>
